import { Input } from "@ember/component";
import { i18n } from "discourse-i18n";
import FormFieldBase from "./base";
import FormFieldWireFrame from "./wire-frame";

export default class FormFieldCheckbox extends FormFieldBase {
  <template>
    <FormFieldWireFrame
      @fieldName={{this.fieldName}}
      @title={{this.title}}
      @hideDescription={{true}}
      @required={{@required}}
      @validation={{@validation}}
    >
      <label class="control-label checkbox-label">
        <Input
          class="circles-form-{{@name}}"
          ...attributes
          name={{this.fieldName}}
          @checked={{@value}}
          @type="checkbox"
        />
        <span>
          <span>
            {{this.description}}
          </span>
          {{#unless @title}}
            {{#if @required}}
              <span class="required_flag">
                {{i18n "discourse_circles.form.required_field_indicator"}}
              </span>
            {{/if}}
          {{/unless}}
        </span>
      </label>
      {{yield}}
    </FormFieldWireFrame>
  </template>
}
